import * as React from 'react';
import './SpinningTickWithLabel.scss';
import SpinningTick from './SpinningTick';
import { childClassClosure, ClassableProps, baseClassAnd } from "@jcharlesworthuk/your-mum-core/dist/functions";
import { useState, useEffect } from 'react';

const baseClass = 'spinning-tick-with-label';
const childClass = childClassClosure(baseClass);

type Props = ClassableProps & {
    isLoading?: boolean;
    title: string;
    labelText: string;
    onMountDelayed?: () => void;
    invertColours?: boolean;
}

const SpinningTickWithLabel: React.FunctionComponent<Props> = (props) => {
    const [delayedMount, setDelayedMount] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setDelayedMount(true);
            if (props.onMountDelayed) {
                props.onMountDelayed();
            }
        }, 1000);
         return () => {
            clearTimeout(timeout);
         }
    }, [])

    const showAsLoading = props.isLoading === true || !delayedMount;
    return <div className={`${baseClassAnd(baseClass, props)} ${showAsLoading || 'load-complete'}`}>
        {/* <h2 className={childClass('title')}>{props.title}</h2> */}
        <div className={childClass('row')}>
            <SpinningTick isLoading={showAsLoading} invertColours={props.invertColours} />
            <span className={childClass('label', props.invertColours ? 'inverse': '')}>{props.labelText}</span>
        </div>
    </div>
}

export default SpinningTickWithLabel;